export const easeOutStrong: [number, number, number, number] = [0.23, 1, 0.32, 1]

export const fadeUp = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.3, ease: easeOutStrong },
}
